import ApplicationSerializer from "./application";

export default class ColocationRackSerializer extends ApplicationSerializer {
  usesProxy = true;
}
